module.exports = __webpack_public_path__ + "static/14_Amazon-625ab971e8361f27b7ccfaf6efa9e41c.png";